/*
投诉处理
*/
import React, { PureComponent } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { Modal, message, Radio, Tag } from 'antd';
import { connect } from 'react-redux';
import model from '@/reducers/aftersale/deliveryticket/model';
import models from '@/reducers/aftersale/deliverycomplain/model';
import { regFenToYuan, regYuanToFen } from '@/util/money';
import { XOKButton, XInputNum, XTextArea, XTitle, XInfoLabel } from '@/components/xqxc_ui';
import http from '@/assets/api/http';

const RadioGroup = Radio.Group;

class ProducDetails extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            title: this.props.title,
            visible: this.props.visible,
            confirmLoading: false,
            disabledArea: false,
            checked: false,
            count: 1,
            punishmentType: {},
        };
    }
    componentDidMount() {
        const { data: { id } } = this.props;
        this.props.getPunishmentDefault({ id });
        // // 惩罚理由
        this.props.getfindNames();
    }
    componentWillReceiveProps(nextProps) {
        const { PunishmentDefault } = nextProps;
        const { count } = this.state;
        if (Object.keys(PunishmentDefault).length > 0 && count == 1) {
            this.setState({
                MONEY: Number(regFenToYuan(PunishmentDefault.fines)),
                LEVELSCORE: PunishmentDefault.levelScore,
                BLOCK: PunishmentDefault.blackDays,
                count: 2
            });
        }
    }
    _handleOk = () => {
        const { punishmentDesc, punishmentType, BLOCK, LEVELSCORE, MONEY, reasons } = this.state;
        const { data: { id } } = this.props;
        if (Object.keys(punishmentType).length == 0) {
            message.warn('惩罚原因必选!');
            return;
        }
        let query = {
            sourceId: id,
            blackDays: BLOCK,
            levelScore: LEVELSCORE,
            fines: regYuanToFen(MONEY),
            punishmentDesc,
            punishmentTypeId: punishmentType.id,
            punishmentType: punishmentType.name,
            reasons: punishmentType.id == 6 ? reasons : undefined,
        };
        http('/?cmd=com.xqxc.api.pig.mis.order.DeliveryComplaintMisService.addPunishment', query, 'POST').then((response) => {
            message.success('新建成功!');
            this.setState({
                visible: false,
                confirmLoading: false,
            });
            this.props.closeMode(true);
            this.props.refresh();
        }).catch((e) => {
            message.error(e.message);
        });
    }
    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }
    // 标签查询
    _targetChecked = i => {
        if (i.name == '其他') {
            this.setState({ disabledArea: true });
        } else {
            this.setState({ disabledArea: false });
        }
        this.setState({
            checked: i.id,
            punishmentType: i,
        });
    }

    render() {
        const { visible, confirmLoading, title, disabledArea, MONEY, reasons, punishmentDesc, checked, BLOCK, LEVELSCORE } = this.state;
        const { PunishmentDefault = {}, findNames = [] } = this.props;
        return (
            <Modal
                width={650}
                centered
                title={title}
                visible={visible}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.col}>
                    <div className={styles.col1}>
                        <XInfoLabel style={{ marginLeft: '70px' }} labelWith={70} label="投诉原因：" value={PunishmentDefault.reasons} />
                    </div>
                    <div className={styles.col2}>
                        <XInfoLabel style={{ marginLeft: '10px' }} labelWith={70} label="投诉说明：" value={PunishmentDefault.othersReason} />
                    </div>
                </div>
                <div className={styles.tableContainer} style={{ overflow: 'auto', overflowX: 'hidden', height: '100%' }}>
                    <div className={styles.orderInfo}>
                        <div className={`${styles.layout}`}>
                            <div className={styles.flex}>
                                <div className={styles.punishmentStyles}>
                                    <label>惩罚形式：</label>
                                    <span className={styles.handleStyles}>
                                        <div className={styles.pushClow}>
                                            <span className={styles.subtitle}>罚  &nbsp;&nbsp;&nbsp;&nbsp;    款</span>
                                            <XInputNum
                                                style={{ width: 220, display: 'inline-block' }}
                                                inputStyle={{ width: 180 }}
                                                label=''
                                                placeholder='请输入'
                                                value={MONEY}
                                                bindThis={this}
                                                bindName='MONEY'
                                                precision={2}
                                                min={0}
                                                max={1000}
                                            />
                                                元 <span className={styles.limit}>最大值1000</span>
                                        </div>
                                        <div className={styles.pushClow}>
                                            <span className={styles.subtitle}>等级分扣</span>
                                            <XInputNum
                                                style={{ width: 220, display: 'inline-block' }}
                                                inputStyle={{ width: 180 }}
                                                label=''
                                                placeholder='请输入'
                                                value={LEVELSCORE}
                                                bindThis={this}
                                                bindName='LEVELSCORE'
                                                precision={0}
                                                min={0}
                                                max={99}
                                            />
                                                分 <span className={styles.limit}>最大值99</span>
                                        </div>
                                        <div className={styles.pushClow}>
                                            <span className={styles.subtitle}>拉 &nbsp;&nbsp;&nbsp;&nbsp;      黑 </span>
                                            <XInputNum
                                                style={{ width: 220, display: 'inline-block' }}
                                                inputStyle={{ width: 180 }}
                                                label=''
                                                placeholder='请输入'
                                                value={BLOCK}
                                                bindThis={this}
                                                bindName='BLOCK'
                                                precision={0}
                                                min={0}
                                                max={99}
                                            />
                                                天 <span className={styles.limit}>拉黑：限制骑士不可接单</span>
                                        </div>
                                    </span>
                                </div>
                                <div className={styles.punishmentStyles}>
                                    <label>惩罚原因：</label>
                                    <div className={styles.punishmentReason}>
                                        {findNames.map(i => {
                                            return <Tag key={i.id} color={checked === i.id ? 'orange' : null} style={{ marginLeft: 10, marginBottom: 10, cursor: 'pointer' }} onClick={() => this._targetChecked(i)}>{i.name}</Tag>;
                                        })}
                                    </div>
                                    {disabledArea && <XTextArea
                                        style={{ marginTop: '30px', marginLeft: 71 }}
                                        inputStyle={{ width: 450, resize: 'none' }}
                                        label=''
                                        placeholder='该理由显示于记录并显示在骑手APP'
                                        value={reasons}
                                        bindThis={this}
                                        bindName='reasons'
                                        maxLength={256}
                                    />}
                                </div>
                                <XTextArea
                                    style={{ marginTop: '30px' }}
                                    inputStyle={{ width: 450, resize: 'none' }}
                                    label='处理说明：'
                                    placeholder=''
                                    value={punishmentDesc}
                                    bindThis={this}
                                    bindName='punishmentDesc'
                                    maxLength={256}
                                />
                            </div>
                        </div>
                    </div>

                </div>
                {/* <XLineConfirmBtn style={{ marginTop: '30px' }} okHandle={this._okHandle} cancelHandle={this._cancelHandle} /> */}
            </Modal>
        );
    }
}

ProducDetails.propTypes = {
    history: PropTypes.object, // 路由history
    match: PropTypes.object,// 路由history
    data: PropTypes.object, // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
    refresh: PropTypes.func,
    getfindNames: PropTypes.func,
    findNames: PropTypes.array,
    getPunishmentDefault: PropTypes.func,
    PunishmentDefault: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        findNames: state.deliveryticket.findNames,
        PunishmentDefault: state.deliverycomplain.PunishmentDefault
    };

};

export default connect(mapStateToProps, { ...model.actions, ...models.actions })(ProducDetails);